export function uint8ArrayToBase64(uint8Array: Uint8Array) {
  return Uint8Array.prototype.toBase64.call(uint8Array);
}
